import React from 'react'
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import HelpTooltip from 'components/HelpTooltip';
import GridBlock from 'components/GridBlock';

const style = theme => ({
	root: {
		'&>*:first-child': {
			width: `calc(100% - ${theme.spacing(3)}px)`
		}
	}
})

function HelpComponent({
	classes,
	children,
	text,
	dangerouslySetTextHTML
}) {
	return (
		<GridBlock className={classes.root} alignItems='center'>
			{children}
			<HelpTooltip text={text} dangerouslySetTextHTML={dangerouslySetTextHTML} />
		</GridBlock>
	)
}

HelpComponent.propTypes = {
	classes: PropTypes.any,
}

export default withStyles(style)(HelpComponent);